import React from 'react'
import { ConfigProvider } from 'antd'
import useButtonStyle from './buttonStyle'
import useTagStyle from './tagStyle'
import useSwitchStyle from './switchStyle'
import useCheckboxStyle from './checkboxStyle'
import useRadioStyle from './radioStyle'
import useSpinStyle from './spinStyle'
import useDividerStyle from './dividerStyle'
import useCardStyle from './cardStyle'
import { PREFIX } from './constant'

interface GeekThemeProviderProps {
  disabled?: boolean
  children?: React.ReactNode
}

export default function GeekThemeProvider({ children, disabled }: GeekThemeProviderProps) {
  const { getPrefixCls } = React.useContext(ConfigProvider.ConfigContext)

  useButtonStyle(getPrefixCls('btn'))
  useTagStyle(getPrefixCls('tag'))
  useSwitchStyle(getPrefixCls('switch'))
  useCheckboxStyle(getPrefixCls('checkbox'))
  useRadioStyle(getPrefixCls('radio'))
  useSpinStyle(getPrefixCls('spin'))
  useDividerStyle(getPrefixCls('divider'))
  useCardStyle(getPrefixCls('card'))

  const passedCls = disabled ? undefined : PREFIX

  return (
    <ConfigProvider
      button={{ className: passedCls }}
      tag={{ className: passedCls }}
      switch={{ className: passedCls }}
      typography={{ className: passedCls }}
      checkbox={{ className: passedCls }}
      radio={{ className: passedCls }}
      spin={{ className: passedCls }}
      divider={{ className: passedCls }}
      card={{ className: passedCls }}
    >
      {children}
    </ConfigProvider>
  )
}
